import React from 'react';

const GradientBar = ({ children, className = '' }) => {
  return (
    <div
      className={`w-full bg-brand-beige text-brand-ink ${className}`}
    >
      {children}
    </div>
  );
};

export default GradientBar;